var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9152 11.4389L1.79388 9.31756C1.59615 9.12143 1.44156 8.88617 1.34001 8.62684C1.23847 8.3675 1.19221 8.08982 1.20419 7.81158C1.21617 7.53333 1.28613 7.26065 1.4096 7.01101C1.53306 6.76137 1.7073 6.54026 1.92116 6.36186C4.33347 4.4224 7.16708 3.07583 10.1943 2.43034C12.9884 1.8075 15.8854 1.8075 18.6796 2.43034C21.7193 3.08002 24.5633 4.43658 26.981 6.39014C27.1942 6.56801 27.3681 6.78832 27.4915 7.03706C27.6149 7.28579 27.6851 7.55749 27.6978 7.83486C27.7104 8.11224 27.6651 8.3892 27.5649 8.64812C27.4646 8.90705 27.3115 9.14226 27.1154 9.33878L24.994 11.4601C24.6543 11.8066 24.2001 12.0178 23.7161 12.0542C23.2321 12.0907 22.7514 11.9499 22.3636 11.6581C21.5952 11.0688 20.7626 10.5682 19.8817 10.1661C19.5334 10.0081 19.2378 9.75367 19.0298 9.43284C18.8217 9.11201 18.71 8.73827 18.7079 8.3559V6.55985C15.931 5.79618 12.9995 5.79618 10.2226 6.55985V8.3559C10.2204 8.73827 10.1087 9.11201 9.9007 9.43284C9.69267 9.75367 9.39702 10.0081 9.04879 10.1661C8.16786 10.5682 7.33525 11.0688 6.56685 11.6581C6.1749 11.9531 5.68819 12.0938 5.19928 12.0534C4.71037 12.013 4.25337 11.7943 3.9152 11.4389Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.969b769550ca3fc69d8d16627e17c455.svg";
export { ForwardRef as ReactComponent };